import { Link, useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { KTSVG } from '../../../../_metronic/helpers'
import { useAuth } from '../../auth/core/AuthProvider'

const DashboardToolbar = () => {
  const { pathname } = useLocation()
  const intl = useIntl()
  const { user } = useAuth()

  const isGroup = pathname === '/dashboard/group'
  const canViewGroupDashboard = user?.permissions?.canViewGroupDashboard ?? false

  if (!isGroup && !canViewGroupDashboard) {
    return null
  }

  const targetHref = isGroup ? '/dashboard' : '/dashboard/group'
  const label = intl.formatMessage({
    id: isGroup ? 'DASHBOARD.SINGLEVIEW' : 'DASHBOARD.GROUPVIEW',
  })

  const iconPath = isGroup
    ? '/media/icons/duotune/layouts/lay001.svg'
    : '/media/icons/duotune/layouts/lay002.svg'

  return (
    <div className='d-flex align-items-center gap-2 gap-lg-3'>
      <Link
        to={targetHref}
        className='btn btn-sm btn-primary d-inline-flex align-items-center gap-2 fw-bold'
        aria-label={label}
        title={label}
      >
        <KTSVG path={iconPath} className='svg-icon-4 svg-icon-muted' />
        <span>{label}</span>
      </Link>
    </div>
  )
}

export { DashboardToolbar }
